import {Component, input} from '@angular/core';
import {Crumbs} from '../../classes/crumb.class';
import {RouterLink} from '@angular/router';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    imports: [
        RouterLink
    ]
})
export class BreadcrumbComponent {
    crumbs = input.required<Crumbs>();
}
